import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import "../Css/Assessmentpurchasingscard.css";

const AssessmentPurchasingsCard = ({ transaction, formatDateTime, userType }) => {
	const [showDetails, setShowDetails] = useState(false);

	const amountSymbol = transaction?.symbol || "Rs.";
	const amount = transaction?.amount || "0.00";
	const assessName = transaction?.assess_name || "Exam Name goes here";
	const paidBy =
		transaction?.paid_by ||
		transaction?.paidBy ||
		transaction?.paidByName ||
		transaction?.paidby ||
		transaction?.created_by ||
		transaction?.createdBy ||
		"N/A";
	const purchasedAt = formatDateTime
		? formatDateTime(transaction?.created_at || transaction?.purchase_date)
		: "-";

	return (
		<>
			<article className="assessment-purchasings-card">
				<div className="assessment-purchasings-card__main">
					<div className="assessment-purchasings-card__top">
						<h3 className="assessment-purchasings-card__title">{assessName}</h3>
					</div>

					<div className="assessment-purchasings-card__details">
						<div className="assessment-purchasings-card__detail-item">
							<span className="assessment-purchasings-card__detail-label">Amount</span>
							<span className="assessment-purchasings-card__detail-value assessment-purchasings-card__detail-value--amount">
								{amountSymbol} {amount}
							</span>
						</div>

						<div className="assessment-purchasings-card__detail-item">
							<span className="assessment-purchasings-card__detail-label">Purchased on</span>
							<span className="assessment-purchasings-card__detail-value">{purchasedAt}</span>
						</div>

						<div className="assessment-purchasings-card__detail-item">
							<span className="assessment-purchasings-card__detail-label">Paid by</span>
							<span className="assessment-purchasings-card__detail-value">{paidBy}</span>
						</div>

						{userType === "parent" && transaction?.student && (
							<div className="assessment-purchasings-card__detail-item">
								<span className="assessment-purchasings-card__detail-label">Student</span>
								<span className="assessment-purchasings-card__detail-value">{transaction.student}</span>
							</div>
						)}
					</div>
				</div>

				<div className="assessment-purchasings-card__actions">
					<Button
						type="button"
						className="assessment-purchasings-card__view-btn"
						onClick={() => setShowDetails(true)}
					>
						<RemoveRedEyeIcon fontSize="small" />
						View Details
					</Button>
				</div>
			</article>

			<Modal size="lg" centered show={showDetails} onHide={() => setShowDetails(false)}>
				<Modal.Header>
					<Modal.Title>Assessment Purchasing Details</Modal.Title>
					<Button variant="secondary" onClick={() => setShowDetails(false)}>
						Close
					</Button>
				</Modal.Header>
				<Modal.Body>
					<div className="transaction-details-grid">
						<div className="detail-row">
							<div className="detail-item">
								<span className="detail-label">Assessment</span>
								<span className="detail-value">{assessName}</span>
							</div>
							<div className="detail-item">
								<span className="detail-label">Amount</span>
								<span className="detail-value">{amountSymbol} {amount}</span>
							</div>
						</div>
						<div className="detail-row">
							<div className="detail-item">
								<span className="detail-label">Purchased on</span>
								<span className="detail-value">{purchasedAt}</span>
							</div>
							<div className="detail-item">
								<span className="detail-label">Paid by</span>
								<span className="detail-value">{paidBy}</span>
							</div>
						</div>
						<div className="detail-row">
							<div className="detail-item">
								<span className="detail-label">Payment Method</span>
								<span className="detail-value">{transaction?.payment_method || "N/A"}</span>
							</div>
							<div className="detail-item">
								<span className="detail-label">Confirmation No</span>
								<span className="detail-value">{transaction?.confirmation_no || transaction?.exam_transaction_id || "N/A"}</span>
							</div>
						</div>
						{userType === "parent" && transaction?.student && (
							<div className="detail-row">
								<div className="detail-item">
									<span className="detail-label">Student</span>
									<span className="detail-value">{transaction.student}</span>
								</div>
								<div className="detail-item" />
							</div>
						)}
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default AssessmentPurchasingsCard;
